(() => {
  if (window.GmlPageTransitions) return;
  const root = document.documentElement;
  const storageKey = 'gml_page_arrival_v1';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const nativeTransitions = 'onpageswap' in window && 'onpagereveal' in window;
  const prefetched = new Set();
  let busy = false;
  let resetTimer;
  let arrival = null;
  try {
    arrival = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    sessionStorage.removeItem(storageKey);
  } catch {}
  const destination = value => {
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|checkout|checkouts|authentication|customer_authentication|apps|admin)(?:\/|$)/i.test(url.pathname)) return null;
      if (/\/cart\/(?:add|change|clear|update)(?:\.js|\.json|\/|$)/i.test(url.pathname)) return null;
      if (url.searchParams.has('logout') || url.searchParams.has('challenge')) return null;
      return url;
    } catch { return null; }
  };
  const sameDocument = url => url.pathname === location.pathname && url.search === location.search;
  const prepare = value => {
    const url = destination(value);
    if (!url || sameDocument(url) || navigator.connection?.saveData || prefetched.has(url.href) || prefetched.size >= 12) return;
    prefetched.add(url.href);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url.href;
    document.head.append(link);
  };
  const reset = () => {
    busy = false;
    clearTimeout(resetTimer);
    root.classList.remove('gml-page-leaving', 'gml-page-arriving');
  };
  const reveal = () => {
    if (reduced.matches) return;
    root.classList.remove('gml-page-leaving');
    root.classList.add('gml-page-arriving');
    window.setTimeout(() => root.classList.remove('gml-page-arriving'), 420);
  };
  const expectedArrival = arrival && Date.now() - arrival.time < 30000;
  if (!nativeTransitions && expectedArrival && !reduced.matches) reveal();
  const navigate = async (value, options = {}) => {
    const url = destination(value);
    if (busy) return;
    busy = true;
    prepare(value);
    try {
      if (options.beforeLeave) await options.beforeLeave();
      if (url && sameDocument(url) && !options.commit) {
        location.assign(url.href);
        reset();
        return;
      }
      if (url && sameDocument(url) && options.commit && !options.menu) {
        options.commit();
        reset();
        return;
      }
      try { sessionStorage.setItem(storageKey, JSON.stringify({time:Date.now(), url:url?.href || location.href})); } catch {}
      if (!nativeTransitions && !reduced.matches && !options.menu) {
        root.classList.add('gml-page-leaving');
        await new Promise(resolve => window.setTimeout(resolve, 140));
      }
      resetTimer = window.setTimeout(reset, 5000);
      if (options.commit) options.commit();
      else location.assign(url?.href || value);
    } catch (error) {
      reset();
      throw error;
    }
  };
  window.GmlPageTransitions = {prepare, navigate};
  const eligibleLink = event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('data-gml-no-transition') || link.hasAttribute('data-gml-back')) return null;
    return link;
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const link = eligibleLink(event);
    if (link) prepare(link.href);
  }, {passive:true});
  document.addEventListener('focusin', event => {
    const link = eligibleLink(event);
    if (link) prepare(link.href);
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = eligibleLink(event);
    if (!link) return;
    const url = destination(link.href);
    if (!url || sameDocument(url)) return;
    event.preventDefault();
    const menu = document.querySelector('[data-gml-navigation]');
    const fromMenu = menu?.gmlHasOpenMenu?.() === true;
    navigate(url.href, fromMenu ? {menu:true,beforeLeave:menu.gmlCloseForNavigation} : {});
  });
  window.addEventListener('pagereveal', event => {
    reset();
    if (!event.viewTransition && expectedArrival) reveal();
    if (event.viewTransition && reduced.matches) event.viewTransition.skipTransition();
  });
  window.addEventListener('pageshow', event => {
    busy = false;
    clearTimeout(resetTimer);
    root.classList.remove('gml-page-leaving');
    if (event.persisted && !nativeTransitions) reveal();
  });
  window.addEventListener('hashchange', reset);
})();
